import { RootState } from 'editor/src/store/index';

// The host sends either only for a print partner's customers, whose threads it may send too.
const hasPrintPartnerSettings = ({ hostSettings: { cmykOnly, printTechRules } }: RootState) =>
  !!cmykOnly || printTechRules !== undefined;

export default hasPrintPartnerSettings;
